import { getPersistor } from '@rematch/persist'
import { PersistGate } from 'redux-persist/lib/integration/react'
import React from "react";
import { Provider } from "react-redux";
import store from "./storage";
import { storyNames } from "./storage/stories";
import * as _ from "lodash";
import Router from "./Router";

const persistor = getPersistor();

const onInitGame = () => {
  store.dispatch.versionManager.runMigrations();

  _.forEach(storyNames, (story) => {
    store.dispatch[story].beginStory();
    return store.dispatch[story].resumeScheduledMessages();
  });
};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

//Fix scrolling
window.addEventListener("touchmove", event => {
  event.preventDefault();
}, { passive: false });

const scrollingDiv = document.getElementById('game');
scrollingDiv.addEventListener('touchmove', function (event) {
  event.stopPropagation();
});

export default () =>
  <PersistGate persistor={persistor} onBeforeLift={onInitGame}>
    <Provider store={store}>
      <Router/>
    </Provider>
  </PersistGate>;
